<form [formGroup]="formGroup">
  <div class="fields-block" style="padding:0;">
    <div class="row mt-1 dni">
      <div class="col-md-5 col-12">
        <sc-select
          formControlName="documentType"
          label="Tipo de documento"
          objectValue="value"
          [items]="documentTypeOptions"
          (optionSelected)="handleOptionSelected($event)"
         ></sc-select>
      </div>
      <div class="col-md-7 col-12">
        <sc-input
          formControlName="idNumber"
          label="Número"
          type="number"
          size="large-fluid"
          [maxlength]="numberMaxLength"
          [icon]="loadingDocumentNumber?'loading':(insuredChecked && insuredOptions.length?'check':'')"
          [placeholder]="numberPlaceholder"
        ></sc-input>
      </div>
    </div>
    <div class="row mb-1 person">
      <div *ngIf="!insuredOptions.length && insuredChecked" class="insured-message col-12">
        <sc-info-box>
          <span [innerHTML]="notFoundMessage"></span>
        </sc-info-box>
      </div>
      <ng-container *ngIf="insuredOptions.length">
        <p *ngIf="insuredOptions.length > 1" class="insured-message col-12">
          Se encontraron {{insuredOptions.length}} personas que tienen el mismo DNI, seleccione la correcta.
        </p>
        <sc-radio-group formControlName="insured" class="col-12">
          <div *ngFor="let item of insuredOptions; let i=index">
            <sc-radio-item type="boxed" [value]="item" [isDisabled]="item.isValid === false" class="radio-item">
              <div >
                {{item.fullName}}
              </div>
            </sc-radio-item>
            <div *ngIf="item.isValid === false" class="invalid-message">
              <span [innerHTML]="item.invalidMessage"></span>
            </div>
          </div>
        </sc-radio-group>
      </ng-container>
    </div>
  </div>
</form>
